module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_2.8276ae3b.png";